import React from 'react';

import SelectMenyAdConfigureSlot from './SelectMenyAdConfigureSlot';
import {
  SERVICE_MENY_LIGHT,
  SERVICE_MENY,
  SERVICE_MENY_GO,
} from 'src/consts/MENY_SERVICE';
import SelectMenyLightAdConfigureSlot from './SelectMenyLightAdConfigureSlot';

import { isUndefined, isNull } from 'lodash';

import active_lang from 'src/langs/jp_en';

export default function SelectAdConfigureSlot({
  service_class,
  formik,
  advertisement_table_data,
}) {
  if (isUndefined(service_class) || isNull(service_class)) {
  } else {
    switch (service_class.id) {
      case SERVICE_MENY:
        return (
          <SelectMenyAdConfigureSlot
            formik={formik}
            advertisement_table_data={advertisement_table_data}
          />
        );

      case SERVICE_MENY_LIGHT:
        return (
          <SelectMenyLightAdConfigureSlot
            formik={formik}
            advertisement_table_data={advertisement_table_data}
          />
        );
      case SERVICE_MENY_GO:
        return (
          <SelectMenyAdConfigureSlot
            formik={formik}
            advertisement_table_data={advertisement_table_data}
          />
        );

      default:
        return <>{JSON.stringify(service_class, null, 2)}</>;
    }
  }

  return <>{active_lang.AD_ACTION_LOADING}</>;
}
